import { BOSubServiceDetail } from './../models/BOSubServiceDetail.model';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BODateRangeFilter } from '../models/BODateRangeFilter.model';
import { IDataSubServiceAgrouped } from '../interfaces/Igeneral.interface';



@Injectable({
  providedIn: 'root'
})
export class SubServiceDetailService {

  myAppUrl = GlobalConstants.apiURL;
  myApiUrl = 'api/SubServiceDetail';

  constructor(private http:HttpClient){}

  getAll():Observable<BOSubServiceDetail[]>{
      return this.http.get<BOSubServiceDetail[]>(this.myAppUrl + this.myApiUrl);
  }

  getSubServicesDetailsBySellDetailId(subService:number ):Observable<BOSubServiceDetail[]>{
    return this.http.get<BOSubServiceDetail[]>(this.myAppUrl + this.myApiUrl + '/'+subService);
  }


  SbsvcsAgroupedByProfessionalIdAndDates(datesFilter:BODateRangeFilter, professionalId:number):Observable<Array<Array<IDataSubServiceAgrouped>>>{
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    }
    const body= JSON.stringify(datesFilter);
    return this.http.post<Array<Array<IDataSubServiceAgrouped>>>(this.myAppUrl + this.myApiUrl + 'SbsvcsAgroupedByProfessionalIdAndDates/'+professionalId,body,httpOptions);
  }

  SbsvcsAgroupedBySubServiceTypeIdAndDates(datesFilter:BODateRangeFilter):Observable<BOSubServiceDetail[][]>{
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    }
    const body= JSON.stringify(datesFilter);
    return this.http.post<BOSubServiceDetail[][]>(this.myAppUrl + this.myApiUrl + '/SbsvcsAgroupedBySubServiceTypeIdAndDates',body,httpOptions);
  }


}
